import React from "react"
import Autocomplete from "react-google-autocomplete"
import { twMerge } from "tailwind-merge"

import "./PlacesAutocomplete.sass"
import { BASE_INPUT_CLASSNAMES, VALIDATION_ERROR_INPUT_CLASSNAMES, ValidationError } from "./Inputs"

const PlacesAutocomplete = ({ types = [], validationError, className, ...props }) => (
  <div>
    <Autocomplete
      {...props}
      options={{ types }}
      className={twMerge(BASE_INPUT_CLASSNAMES, className, validationError && VALIDATION_ERROR_INPUT_CLASSNAMES)}
    />
    {validationError && <ValidationError>{validationError}</ValidationError>}
  </div>
)

export default PlacesAutocomplete
